import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var LoginConfigURL = {
    authroizationToken: URLConfig.config.apiBase + microService.userService + "AuthenticateToken",
    // newLogin: URLConfig.config.apiBase + microService.userService + "Login",
    newLogin: URLConfig.config.apiBase + microService.userService + "loginAd",
    // validateOTP:
    // URLConfig.config.apiBase + microService.userService + "validatelogin",
    validateOTP: URLConfig.config.apiBase + microService.userService + "validateloginAd",
    //newLogin: URLConfig.config.apiBase + microService.userService + "Login",
    newLoginEncrypted: URLConfig.config.apiBase + microService.userService + "loginencrypted",
    // validateOTP:URLConfig.config.apiBase + microService.userService + "validatelogin",
    validateOTPEncrypted: URLConfig.config.apiBase +
        microService.userService +
        "validateloginencrypted",
    forgotPassword: URLConfig.config.apiBase + microService.userService + "ForgotPassword",
    validateForgotPassword: URLConfig.config.apiBase +
        microService.userService +
        "ValidateForgotPassword",
    resetPassword: URLConfig.config.apiBase + microService.userService + "ResetPassword",
    ForgotResetPassword: URLConfig.config.apiBase + microService.userService + "ForgotResetPassword",
    userUnblockCheck: URLConfig.config.apiBase + microService.userService + "UserUnblockCheck",
    userUnblock: URLConfig.config.apiBase + microService.userService + "UserUnblock",
    changePassword: URLConfig.config.apiBase + microService.userService + "ChangePassword",
    validateChangePassword: URLConfig.config.apiBase +
        microService.userService +
        "ValidateChangePassword",
    // logout: URLConfig.config.apiBase + microService.userService + "logout",
    logout: URLConfig.config.apiBase + microService.userService + "logoutAd",
    resendOTP: URLConfig.config.apiBase + microService.userService + "resendOtp",
    FRDRedirectionURL: URLConfig.config.apiBase + microService.userService + "FPDRedirectionUrl",
    validateSingleSignOnURL: URLConfig.config.apiBase + microService.userService + "SSOLogin",
    forgotLogin: URLConfig.config.apiBase + microService.userService + "ForgotLogin",
    validateForgotLogin: URLConfig.config.apiBase + microService.userService + "validateForgotLogin",
    guidToken: URLConfig.config.apiBase + microService.userService + "guidToken",
};
export default LoginConfigURL;
